module.exports = __webpack_public_path__ + "static/media/C70B03D9-8446-43D6-A568-582390E2C014.928ae640.jpeg";